import AccountCompletionForm from './AccountCompletionForm';

export default AccountCompletionForm;